import { LoadDoctorDocument } from 'domain/usecases/doctor/load-doctor-document'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadDoctorDocument implements LoadDoctorDocument {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }
  load(params: LoadDoctorDocument.Params): Promise<LoadDoctorDocument.Model> {
    return this.doctorRepository.loadDoctorDocument(params)
  }
}
